import { useEffect, useState } from 'react';
import iamApi from '../services/iamApi';
import { useAuth } from '../contexts/AuthContext';

// Shared `type_id → label` map for the active org's item types, so search results
// can show a type badge (requirement / container / hazard / …) like the mockup.
// Module-cached per org so the palette + dropdown don't each refetch.
const cache = new Map(); // orgId -> { [typeId]: label }

export function useTypeMap() {
  const { activeOrg } = useAuth();
  const [map, setMap] = useState(() => cache.get(activeOrg) || {});

  useEffect(() => {
    if (!activeOrg) { setMap({}); return undefined; }
    if (cache.has(activeOrg)) { setMap(cache.get(activeOrg)); return undefined; }
    let cancelled = false;
    Promise.resolve(iamApi.orgItemTypes(activeOrg))
      .then((rows) => {
        const m = {};
        (Array.isArray(rows) ? rows : []).forEach((t) => {
          if (t && t.id) m[t.id] = t.label || t.name || t.id;
        });
        cache.set(activeOrg, m);
        if (!cancelled) setMap(m);
      })
      .catch(() => { if (!cancelled) setMap({}); });
    return () => { cancelled = true; };
  }, [activeOrg]);

  return map;
}

// Test helper: clear the module-level cache so a fresh mock takes effect per test.
export function __resetTypeMapCache() { cache.clear(); }

export default useTypeMap;
